import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheApi, AssistitiApi, EntiApi, OperatoriApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useTipiContattiDataSource() {
    const api = new AnagraficheApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getTipiContatti({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getTipoContattoById({
                tenantId: currentTenant.Id,
                tipoContattoId: key
            });
          },
    
          insert: (values) => {
            return api.insertTipoContatto({
                tenantId: currentTenant.Id,
                tipoContattoCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateTipoContatto({
                tenantId: currentTenant.Id,
                tipoContattoId: key,
                tipoContattoUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteTipoContatto({
                tenantId: currentTenant.Id,
                tipoContattoId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


